<template>
<modal @close="$emit('close')" size="large" class="modal-overlay modal-custom">
	<template #header>
		<div>
			<h3 v-if="config && config.title">
				{{ config.title }}
			</h3>
		</div>
	</template>
	<template #body>
		<div v-if="config && config.picture" class="d-flex justify-content-center">
			<img :src="config.picture" />
		</div>
		<div v-html="configDescription" />
	</template>
	<template slot="footer">
		<button type="button" class="btn btn-light" @click="$emit('close')">
			{{ $t("Close") }}
		</button>
	</template>
</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { nl2br, sanitizeHtml } from '@/lib/helper';

export default {
	name: 'ModalPopup',
	components: {
		Modal,
	},
	props: {
		config: {
			type: Object,
			default: null,
		},
		open: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		configDescription() {
			return sanitizeHtml(nl2br(this.config?.description));
		},
	},
};
</script>

<style lang="scss">
.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5); /* Warna latar belakang dengan opasitas */
	backdrop-filter: blur(5px); /* Efek blur untuk latar belakang */
}

.modal-custom {
	.modal-container {
		border-radius: 16px;
		.modal-header {
			background-color: transparent;
		}
		.modal-footer {
			background-color: transparent;
			border: none;
		}
	}
}
</style>
